export default __webpack_public_path__ + "caf8a17013f12237816f686e25782691.mp3";